import {
  Dialog,
  DialogTitle,
  FormControl,
  FormHelperText,
  Input,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDropzone } from "react-dropzone";
import { StyledButton } from "../../../common/components/Button";
import { InputLabel } from "../../../common/components/InputLabel";
import { useForm, useFieldArray } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { submitDesign } from "../../../api/caseApi";
import { deepPurple, grey, purple } from "@mui/material/colors";
import { DialogHeader } from "../styles";
import { CircularProgress } from "@mui/material";
const SubmitDesignDialog = ({ caseId, open, onClose }) => {
  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
    control,
    trigger,
    watch,
    reset,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        link: yup.string().url("Link must be a valid url.").nullable(),
        note: yup.string().nullable(),
        files: yup.array().of(yup.mixed()).required("Files is required."),
      })
    ),
  });

  const { append, remove } = useFieldArray({
    control,
    name: "files",
  });

  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted: (files) => {
      files.map((file) =>
        append({
          file: file,
          type: 4,
          subType: 0,
        })
      );

      trigger("files");
    },
  });

  useEffect(() => {
    if (open === false) {
      reset();
    }
  }, [open, reset]);

  const files = watch("files");
  console.log(errors);

  const handleDesignSubmit = async (values) => {
    const formData = new FormData();
    formData.append("link", values.link);
    formData.append("note", values.note);
    formData.append("caseId", caseId);

    values.files.forEach((fileDetails) => {
      formData.append("files", fileDetails.file);
    });

    try {
      await submitDesign(formData);

      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  const handleRemoveFile = (index) => {
    remove(index);
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      {isSubmitting && <LinearProgress />}
      <Dialog open={isSubmitting}>
        <Box sx={{ paddingX: 10, paddingY: 10 }}>
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
          <Typography sx={{ marginTop: 4, color: grey[600] }}>
            Please wait while we process your request.
          </Typography>
        </Box>
      </Dialog>
      <Box
        component="form"
        onSubmit={handleSubmit(handleDesignSubmit)}
        sx={{ px: 3, py: 2 }}
      >
        <DialogHeader>Submit Design</DialogHeader>
        <br />
        <Box sx={{ cursor: "pointer" }} {...getRootProps()}>
          <input {...getInputProps()} />
          <InputLabel sx={{ display: "block" }}>Files</InputLabel>
          <Box
            sx={{
              padding: 4,
              border: "1px dashed " + grey[400],
              backgroundColor: grey[100],
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: grey[200],
                borderColor: deepPurple[400],
              },
            }}
          >
            Select or drag file/s
          </Box>
          <FormHelperText error variant="outlined">
            {Boolean(errors.files) && errors.files.message}
          </FormHelperText>
        </Box>
        <Box sx={{ marginTop: 1 }}>
          <Typography sx={{ fontWeight: 600 }}>Selected Files</Typography>
          {files &&
            files.map((fileDetails, idx) => (
              <Grid container height={"20px"} marginTop={1}>
                <Grid item xs={7}>
                  <Typography
                    key={JSON.stringify(fileDetails)}
                    sx={{ color: grey[600] }}
                  >
                    {fileDetails.file.name}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => handleRemoveFile(idx)}
                    style={{
                      cursor: "pointer",
                      color: "#808080",
                      width: "14px",
                      height: "14px",
                      "&:hover": {
                        backgroundColor: "red",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            ))}
        </Box>
        <Box sx={{ paddingTop: 2 }}>
          <FormControl fullWidth error={Boolean(errors.link)}>
            <InputLabel sx={{ display: "block" }}>Link</InputLabel>
            <TextField
              fullWidth
              size="small"
              error={Boolean(errors.link)}
              {...register("link")}
            />
            <FormHelperText>
              {Boolean(errors.link) && errors.link.message}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box sx={{ paddingTop: 2 }}>
          <FormControl variant="filled" fullWidth error={Boolean(errors.note)}>
            <InputLabel sx={{ display: "block" }}>Note</InputLabel>
            <TextField
              fullWidth
              multiline
              rows={8}
              size="small"
              error={Boolean(errors.note)}
              {...register("note")}
            />
            <FormHelperText>
              {Boolean(errors.note) && errors.note.message}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            paddingTop: 2,
          }}
        >
          <StyledButton
            type="button"
            theme="purple"
            sx={{ marginLeft: "auto" }}
            disabled={isSubmitting}
            onClick={onClose}
          >
            Cancel
          </StyledButton>
          <StyledButton
            type="submit"
            theme="green"
            sx={{ marginLeft: 1.5 }}
            disabled={isSubmitting}
          >
            Submit
          </StyledButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SubmitDesignDialog;
